import { EnvConfigReceiptLookup } from '../interfaces/env-interfaces';

/**
 * The configuration is used throughout the application to determine how to connect
 * to the backend services and to set up the application dev environment.
 */
export const environment: EnvConfigReceiptLookup = {
    production: false,
    useLock: true,
    appConfig: {
        envRegion: 'eu-west-1',
        envType: 'dev',
        apiBaseUrl: 'dev.chargeye.io',
        appBaseHostname: 'receipts.dev.chargeye.io',
    },
    waf: {
        /** CAPTCHA site key for AWS WAF, used for Javascript integration
         * Please note that this is not a secret, it's safe to expose in the frontend code
         * the key is only used for specific domain and the actual validation is done in AWS WAF
         */
        captchaSiteKey:
            'NVSqaezI/Fa+hJGk1ccEieoHGt3YFDsn6SWcHEtb/aRVhK3TQ3+Wo69ekNIOBARV8bIE6f+9qMNqValt744rlSU4BQivgpfQJBRcmb62PbNtewji+PZbCv1l0r++CvFiTHuOjJbk/cWrUDym/PmD4el4St70BixLvf0rGdhb4RkMiMrA1hKmSfNxIY+PUQWP5P6MDXN0PYAq4bfM9VyqgeLwDhwqnArd5zmzfjQ2S+BjdFFZF0T5RAkvOr5kENqfsqFZSw5CT8SPBrmaHb8o2R/3k9DSayXKm7s1BTp8w4n7ch8hwaj06a5WrJFP+zWchzXglvaDG1uU73WsF0qi5lRkHHjSnPNrRrciakhOGvfcDRGFGpIO2OwfHTjaoAoyRraGkdV0atX9Qb0b4U5Qgn3igYHnyvxFUGM5UbuQqSS1VNdo8IJObpPUPzArrf8XvdXOzOaj4HJ7DAckNZO1gAK8MLiTW+JcI3qWmh2bmbvuyJNnnTTgoEXGWVrlrf9QbwjDzd9v91k6D985d8rV8UPX0F0NF7LuZGzsUavaku5Frgy8cmnO5k8GiVEFDPprntdKh3hgQD5J+4+1SAdUQaHcykDCGoWDlvY406VMKYQ2n5iqj1Lv35rtWPQ6GyQC8YJi9sGBB23iDw660dj0fFo6OJEPTIuZFYOVIV76aRU=_0_1',
        captchaScriptUrl: 'https://34c1b5d6f561.eu-west-1.captcha-sdk.awswaf.com/34c1b5d6f561/jsapi.js',
    },
};
